<template>
  <section>
    <v-tabs dark slider-color="red">
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-card class="px-4 py-4">
      <router-view />
    </v-card>
  </section>
</template>

<script>
  export default {
    name: 'Attendee',
    data () {
      return {
        tabs: [
          {
            name: 'All Attendee',
            route: 'all-attendee'
          },
          {
            name: 'Crypto Traders',
            route: 'crypto-trader'
          },
          {
            name: 'Regular Attendee Type',
            route: 'regular-attendee-type'
          },
          {
            name: 'VIP Attendee Type',
            route: 'vip-attendee-type'
          },
          {
            name: 'VIP Invitation',
            route: 'vip-invitation'
          },
          {
            name: 'Black list',
            route: 'blacklist'
          },
          // {
          //   name: 'Attendees Messages',
          //   route: 'attendees-messages'
          // },
          {
            name: 'Regular Invitation',
            route: 'regular-invitation'
          },
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/index.vue